// Based on https://web.dev/articles/lazy-loading-video

import { ScrollTrigger } from '../global/gsap';

const initLazyVideo = (videos) => {
    if ('IntersectionObserver' in window) {
        const lazyVideoObserver = new IntersectionObserver((entries) => {
            entries.forEach((video) => {
                if (video.isIntersecting) {
                    // If single video with data-src
                    if (video.target.dataset.src) {
                        video.target.src = video.target.dataset.src;
                    // Else if video with multiple source tags
                    } else {
                        video.target.children.forEach((source, i) => {
                            const videoSource = video.target.children[i];

                            if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                                videoSource.src = videoSource.dataset.src;
                            }
                        });
                    }

                    video.target.load();
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });

        const playPauseObserver = new IntersectionObserver((entries) => {
            entries.forEach((video) => {
                if (video.isIntersecting) {
                    if (video.target.paused && video.target.readyState === 4) {
                        video.target.play();
                    }
                } else if (!video.target.paused) {
                    video.target.pause();
                }
            });
        });

        videos.forEach((lazyVideo) => {
            lazyVideoObserver.observe(lazyVideo);
            playPauseObserver.observe(lazyVideo);

            // When video can be played, play it
            lazyVideo.addEventListener('canplaythrough', () => {
                if (lazyVideo.readyState === 4) {
                    lazyVideo.play();
                    ScrollTrigger.refresh();
                }

                lazyVideo.classList.add('loaded');
            }, { once: true });
        });
    }
};

export default initLazyVideo;
